export enum MediaPreviewAction {
  CREATE = 0,
  SELECT = 1
}